import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import "./setUpProject.css";
import { Submit } from "../../Components/Button";
import Select from "react-select";
import axios from "axios";
import { motion } from "framer-motion";
import swal from "sweetalert";
import { addNewColumn } from "../../services/api/apiHandler";
import { useDispatch, useSelector } from "react-redux";
import { fetchColumns } from "../../redux/actions/TemplateTabs/actionNewColumns";

function AssignValuesData(props) {
  const project_id = localStorage.getItem("project_id");
  const dispatch = useDispatch();
  const { nctLoading, nct_error_message, nctIsSuccess, newColumns } = useSelector((state) => state.NCTable);

  const [show, setShow] = useState(false);
  const [temp, setTemp] = useState([]);
  const [info, setInfo] = useState([]);
  const [valid, setValid] = useState(true);
  const [option, setOption] = useState([]);
  const [ledgerNameOption, setLedgerNameOption] = useState([]);
  const [currentOption, setCurrentOption] = useState([]);
  const [previousOption, setPreviousOption] = useState([]);
  const [newcolumn, serNewColumn] = useState(false);
  const [columnname, setColumnName] = useState({
    columnname: "",
  });
  const i = props.index;
  const fileData = props.projectData;
  let header = props.headers;


  const units = [
    { value: "Whole Numbers", label: "Whole Numbers" },
    // { value: 'Tens', label: 'Tens' },
    { value: "Hundreds", label: "Hundreds" },
    { value: "Thousands", label: "Thousands" },
    { value: "Lakhs", label: "Lakhs" },
    { value: "Crores", label: "Crores" },
  ];

  useEffect(() => {
    setOption([]);
    props.headers.map((val) => {
      setOption((option) => [...option, { value: val, label: val }]);
    });
  }, []);

  const handleSelect = (field, e) => {
    props.setName({ ...props.Name, [field]: e.value });
    if (field === "LedgerCode") {
      const res = option.filter((line) => {
        if (!(line.value === e.value)) {
          return line;
        }
      });
      setLedgerNameOption(res);
    } else if (field === "ledgerName") {
      const res = ledgerNameOption.filter((line) => {
        if (!(line.value === e.value)) {
          return line;
        }
      });
      setCurrentOption(res);
    } else if (field === "currentBalance") {
      const res = currentOption.filter((line) => {
        if (!(line.value === e.value)) {
          return line;
        }
      });
      setPreviousOption(res);
    }
  };

  function handleValid() {
    let arr = Object.values(props.Name);

    if (props.Name.LedgerCode === "" && props.Name.ledgerName === "") {
      setValid(false);
      return;
    } else if (props.Name.LedgerCode === "" || props.Name.ledgerName === "") {
      setValid(true);
    }

    if (
      props.Name.currentBalance === "" ||
      props.Name.previousBalance === "" ||
      props.Name.tbAmount.includes === ""
    ) {
      setValid(false);
    } else {
      setValid(true);
    }
  }
  useEffect(() => {
    let obj = Object.values(props.Name);
    let headers = header.filter((item) => !obj.includes(item));
    setTemp(headers);
    handleValid();
  }, [props.Name]);

  function handleNewInput() {
    if (newcolumn === true) {
      serNewColumn(false);
    } else {
      serNewColumn(true);
    }
  }

  function handleModal() {
    setShow(false);
    props.setShow(false);
  }

  useEffect(() => {
    setShow(props.show);
    setInfo(props.info);
  }, [props.show]);

  const handleNewColumn = (e) => {
    setColumnName({ columnname: e });
  };


  const handleNewColumnUpdate = () => {
    if (columnname.columnname === "") {
      swal("", "Please enter column name.", "warning");
      return;
    }

    addNewColumn(project_id, {
      column_name: columnname.columnname,
    }).then((response) => {
      if (response.status === 200) {
        serNewColumn(false);
        dispatch(fetchColumns(project_id))
        swal("", response.data.message, "success");
      }
    }).catch((error) => {
      swal("", error.response.data.error, "error");
    });
  };

  return (
    <div className="Map">
      <Modal
        show={show}
        aria-labelledby="example-modal-sizes-title-lg"
        dialogClassName="modal-90w"
        centered
        size="xl"
      >
        <Modal.Body>
          <motion.div
            className="mapping-container"
            initial={{ y: "-5vh" }}
            animate={{ y: 0 }}
          >
            <div className="file-name">
              <div className="mapHeader">
                <h1>{info[0] ? info[0].name : "File Name"}</h1>
                <p>
                  confirm the column headings given in the above mentioned file.
                </p>
              </div>
              <div>
                <img></img>
              </div>
            </div>
            <div className="input-map">
              <div className="map-input">
                <p>
                  Name of the Branch
                  {/* <span>*</span> */}
                </p>
                <Select
                  placeholder=""
                  as="select"
                  options={option}
                  // onChange={(e)=>{handleSelect('branchName',e)}}
                  theme={(theme) => ({
                    ...theme,
                    borderRadius: "6px",
                    colors: {
                      ...theme.colors,
                      backgroundColor: "white",
                      primary25: "#03565a98",
                      primary: "#03565A",
                    },
                    spacing: {
                      ...theme.spacing,
                      controlHeight: 50,
                    },
                  })}
                />
                {/* <input type='text'
                                    onChange={(e)=>{handleChange('branchName',e)}} 
 
                                    /> */}
              </div>
              <div className="map-input">
                <p>
                  Ledger Code
                  <span>{props.Name.ledgerName ? "" : "*"}</span>
                </p>
                <Select
                  placeholder=""
                  as="select"
                  options={option}
                  onChange={(e) => {
                    handleSelect("LedgerCode", e);
                  }}
                  theme={(theme) => ({
                    ...theme,
                    borderRadius: "6px",
                    colors: {
                      ...theme.colors,
                      backgroundColor: "white",
                      primary25: "#03565a98",
                      primary: "#03565A",
                    },
                    spacing: {
                      ...theme.spacing,
                      controlHeight: 50,
                    },
                  })}
                />
              </div>
              <div className="map-input">
                <p>
                  Ledger Name<span>{props.Name.LedgerCode ? "" : "*"}</span>
                </p>
                <Select
                  placeholder=""
                  as="select"
                  // options={ledgerNameOption}
                  options={option}
                  onChange={(e) => {
                    handleSelect("ledgerName", e);
                  }}
                  theme={(theme) => ({
                    ...theme,
                    borderRadius: "6px",
                    colors: {
                      ...theme.colors,
                      backgroundColor: "white",
                      primary25: "#03565a98",
                      primary: "#03565A",
                    },
                    spacing: {
                      ...theme.spacing,
                      controlHeight: 50,
                    },
                  })}
                />
              </div>
              <div className="map-input">
                <p>
                  Current year Net Balance Column<span>*</span>
                </p>
                <Select
                  placeholder=""
                  as="select"
                  // options={currentOption}
                  options={option}
                  onChange={(e) => {
                    handleSelect("currentBalance", e);
                  }}
                  theme={(theme) => ({
                    ...theme,
                    borderRadius: "6px",
                    colors: {
                      ...theme.colors,
                      backgroundColor: "white",
                      primary25: "#03565a98",
                      primary: "#03565A",
                    },
                    spacing: {
                      ...theme.spacing,
                      controlHeight: 50,
                    },
                  })}
                />
              </div>
              <div className="map-input">
                <p>
                  Previous year Net Balance Column<span>*</span>
                </p>
                <Select
                  placeholder=""
                  as="select"
                  // options={previousOption}
                  options={option}
                  onChange={(e) => {
                    handleSelect("previousBalance", e);
                  }}
                  theme={(theme) => ({
                    ...theme,
                    borderRadius: "6px",
                    colors: {
                      ...theme.colors,
                      backgroundColor: "white",
                      primary25: "#03565a98",
                      primary: "#03565A",
                    },
                    spacing: {
                      ...theme.spacing,
                      controlHeight: 50,
                    },
                  })}
                />
              </div>
              <div className="map-input">
                <p>
                  Amount in Trial Balance<span>*</span>
                </p>
                <Select
                  placeholder=""
                  as="select"
                  options={units}
                  onChange={(e) => {
                    handleSelect("tbAmount", e);
                  }}
                  theme={(theme) => ({
                    ...theme,
                    borderRadius: "6px",
                    colors: {
                      ...theme.colors,
                      backgroundColor: "white",
                      primary25: "#03565a98",
                      primary: "#03565A",
                    },
                    spacing: {
                      ...theme.spacing,
                      controlHeight: 50,
                    },
                  })}
                />
              </div>
              {newColumns &&
                newColumns.length > 0 &&
                newColumns.map((columnName, i) => (
                  <div className="map-input" key={i}>
                    <p>{columnName?.Header && columnName.Header}</p>
                    <Select
                      placeholder=""
                      as="select"
                      options={option}
                      onChange={(e) => {
                        handleSelect(
                          columnName?.accessor && columnName.accessor,
                          e
                        );
                      }}
                      theme={(theme) => ({
                        ...theme,
                        borderRadius: "6px",
                        colors: {
                          ...theme.colors,
                          backgroundColor: "white",
                          primary25: "#03565a98",
                          primary: "#03565A",
                        },
                        spacing: {
                          ...theme.spacing,
                          controlHeight: 50,
                        },
                      })}
                    />
                  </div>
                ))}
              <div
                className="map-input"
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginTop: "2rem",
                }}
              >
                <p
                  style={{
                    fontWeight: "600",
                    fontSize: "1rem",
                    color: "grey",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    handleNewInput();
                  }}
                >
                  +&nbsp;Add&nbsp;column
                </p>
                &nbsp;&nbsp;&nbsp;&nbsp;
                {newcolumn && (
                  <input
                    type="text"
                    style={{ width: "400px" }}
                    onChange={(e) => {
                      handleNewColumn(e.target.value);
                    }}
                  />
                )}
                {newcolumn && (
                  <div className="submit-btn" onClick={handleNewColumnUpdate}>
                    {<Submit sm value="save" />}
                  </div>
                )}
              </div>
            </div>
            <div className="map-button">
              <div
                className="close-btn"
                style={{ cursor: "pointer" }}
                onClick={handleModal}
              >
                Close
              </div>
              <div className="submit-btn" onClick={props.handleSubmit}>
                {<Submit sm value="Confirm & proceed" />}
              </div>
            </div>
          </motion.div>
        </Modal.Body>
      </Modal>
    </div>
  );
}
export default AssignValuesData;
